import { createApi } from "@reduxjs/toolkit/query/react";
import baseQueryWithReauth from "../../utils/baseQueryWithReauth";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    signup: builder.mutation({
      query: (userData) => ({
        url: "/WebAuth/Signup",
        method: "POST",
        body: userData,
      }),
    }),
    login: builder.mutation({
      query: (credentials) => ({
        url: "/WebAuth/Login",
        method: "POST",
        body: credentials,
      }),
    }),
    socialLogin: builder.mutation({
      query: (socialData) => ({
        url: "/WebAuth/WebSocialLogin",
        method: "POST",
        body: socialData,
      }),
    }),
    resetPassword: builder.query({
      query: (credentials) => ({
        url: `/WebAuth/ForgetPassword?email=${encodeURIComponent(credentials.email)}`,
        method: "POST",
      }),
    }),
    verifyEmail: builder.mutation({
      query: ({ id, token }) => ({
        url: `/WebAuth/VerifyEmail?id=${id}&token=${token}`,
        method: "POST",
      }),
    }),
    resendVerificationEmail: builder.mutation({
      query: ({email}) => ({
        url: `/WebAuth/ResendVerificationLink?email=${encodeURIComponent(email)}`,
        method: "POST",
      }),
    }),
    reviewTutor: builder.mutation({
      query: ({ tutorId, count, comment }) => ({
        url: `/WebAuth/ReviewTutor`,
        method: "POST",
        params: { tutorId, count, comment },
        responseHandler: async (response) => {
          const text = await response.text();
          try {
            return JSON.parse(text);
          } catch {
            return { succeeded: true, data: text };
          }
        },
      }),
    }),
  }),
});

export const { 
  useSignupMutation, 
  useLoginMutation, 
  useSocialLoginMutation,
  useResendVerificationEmailMutation, 
  useVerifyEmailMutation, 
  useLazyResetPasswordQuery,
  useReviewTutorMutation 
} = authApi;